import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

export type OfflineFooterProps = {}

export default function OfflineFooter(props: OfflineFooterProps) {
    const theme = useTheme()
    const { t } = useTranslation()

    return (
        <Box
            component="footer"
            sx={{
                py: 2,
                px: 2,
                mt: 'auto',
                backgroundColor: theme.palette.background.paper,
                borderTop: `1px solid ${theme.palette.divider}`,
                textAlign: 'center',
            }}
        >
            <Typography variant="caption" color="text.secondary">
                {t('Offline Mode')} - {t('Data will sync when connection is restored')}
            </Typography>
        </Box>
    )
} 